import { useTranslation } from '@rhino-project/core/i18n';
import { useWatch } from 'react-hook-form';

import { useEffect, useMemo } from 'react';
import { filterPillText, useModelFilterField } from '../../../form';
import { useModelFiltersContext } from '@rhino-project/core/hooks';
import { FieldSelect } from '../../../FieldSelect';
import { ListBoxItem } from '@heroui/react';

export const ModelFilterIntegerSelect = ({
  path,
  ...props
}: {
  path: string;
  [key: string]: unknown;
}) => {
  const { t } = useTranslation();
  const { attribute, operator, operatorPath, ...rest } =
    useModelFilterField(path);

  // Both bounds are offered, and an exclusive bound moves one step inward
  const integers = useMemo(() => {
    const minimum = attribute.exclusiveMinimum
      ? attribute.minimum! + 1
      : attribute.minimum!;
    const maximum = attribute.exclusiveMaximum
      ? attribute.maximum! - 1
      : attribute.maximum!;

    return Array.from({ length: maximum - minimum + 1 }, (_x, i) => ({
      id: minimum + i,
      display_name: `${minimum + i}`
    }));
  }, [attribute]);

  const watch = useWatch({ name: operatorPath });
  const { setPill } = useModelFiltersContext();

  useEffect(() => {
    if (watch !== undefined && watch !== '')
      setPill(operatorPath, filterPillText(attribute, operator, watch));
  }, [attribute, operator, operatorPath, setPill, watch]);

  return (
    <FieldSelect
      path={operatorPath}
      placeholder={t('rhino.frontend.messages.select_a_value', {
        value1: attribute.readableName.toLowerCase()
      })}
      items={integers}
      {...(rest as Record<string, unknown>)}
      {...props}
    >
      {(integer: { id: number; display_name: string }) => (
        <ListBoxItem id={integer.id} textValue={integer.display_name}>
          {integer.display_name}
        </ListBoxItem>
      )}
    </FieldSelect>
  );
};
